export class HideMenuItems {
    constructor(optionalOptions = {}) {
        this._list = document.querySelector('.payment-screen-order--list--hidden');
        if (!this._list) {
            this.destructor();
            return true;
        }

        this._items = this._list.querySelectorAll('div.menu-list-item--wrap');

        if (this._items.length <= 2) {
            this.destructor();
            return true;
        }

        let height = 0;

        height = this._items[0].offsetHeight + this._items[1].offsetHeight;

        this._list.style["max-height"] = height + 5 + "px"
    }

    destructor() {
        this._list = null;
    }
}

export default new HideMenuItems();